export default {
    // private
    dashboard: '/',
    overview: '/overview',
    overviewTwo: '/overview/two',
    overviewThree: '/overview/three',
    tickets: '/tickets',
    ideas: '/ideas',
    ideasTwo: '/ideas/two',
    ideasThree: '/ideas/three',
    contacts: '/contacts',
    agents: '/agents',
    articles: '/articles',
    settings: '/settings',
    subscription: '/subscription',
    // auth
    login: '/login',
    signup: '/signup',
    forgotPassword: '/forgot_password'
};
